module.exports = __webpack_public_path__ + "static/browsenotifs-5d247815843f866cd85bf2c372734dea.png";